import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api";

export type LogServizio = "core" | "web";
export type LogLivello = "DEFAULT" | "DEBUG" | "INFO" | "WARNING" | "ERROR";

export interface LogEntry {
  timestamp: string | null;
  severity: string | null;
  service: string;
  payload: Record<string, unknown> | string | null;
  labels: Record<string, string> | null;
  trace: string | null;
}

export interface LogsResponse {
  entries: LogEntry[];
  info?: string;
  filter?: string;
  limit_applicato?: number;
}

export interface LogsFilter {
  service: LogServizio;
  level: LogLivello;
  minuti: number;
  q?: string;
  limit?: number;
}

export function useAdminLogs(filter: LogsFilter) {
  const params = new URLSearchParams({
    service: filter.service,
    level: filter.level,
    minuti: String(filter.minuti),
    limit: String(filter.limit ?? 100),
  });
  if (filter.q) params.set("q", filter.q);

  return useQuery({
    queryKey: ["admin-logs", filter],
    queryFn: () => apiFetch<LogsResponse>(`/api/v1/admin/logs?${params.toString()}`),
    staleTime: 5_000,
    refetchInterval: 15_000,
  });
}
